import { useLanguage } from '@/contexts/LanguageContext';

export const TypingIndicator = ({ typingUsers }) => {
  const { t } = useLanguage();

  if (typingUsers.length === 0) return null;

  return (
    <div className="px-4 py-2 border-t border-slate-800">
      <div className="flex items-center gap-2 text-sm text-slate-400">
        <div className="flex gap-1">
          <span className="w-2 h-2 bg-pink-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <span className="w-2 h-2 bg-pink-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <span className="w-2 h-2 bg-pink-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
        <span>
          {typingUsers.map(u => u.user_name).join(', ')} {t('typing')}
        </span>
      </div>
    </div>
  );
};

export default TypingIndicator;
